<template>
  <Modal v-model="show" :mask-closable="false"  :loading="loading">
    <div slot="header" class="modal-header">批量导入</div>
    <Row>
      <Col :span="10" :offset="4">
        <Upload class="batchImport" ref="upload" :action="baseUrl+'/perGoalEstimation/batchImport'" :headers="{'Access-Token':token}" :format="['xlsx','xls']" :before-upload="beforeUpload" :on-progress="onProgress" :on-error="handleError" :on-success="handleSuccess" :on-format-error="handleFormatError">
          <Button type="primary" icon="ios-cloud-upload-outline">本地文件导入</Button>
          <div slot="tip">
            <Button v-if="showTip" id="tip" loading>导入中...</Button>
          </div>
        </Upload>
      </Col>
      <Col :span="8" >
        <a id="download" class="ivu-btn ivu-btn-default" :href="baseUrl+'/perGoalEstimation/target/template/download'"><Icon type="ios-cloud-download-outline"></Icon>下载模版</a>
      </Col>
    </Row>
    <div slot="footer">
    </div>
  </Modal>
</template>

<script type="text/ecmascript-6">
import { getToken } from '@/utils/auth';
import {getBaseUrl} from "../../../../utils/public";

export default {
  props: {
    i: {
      type: Number,
      default: 0
    }
  },
  created(){
    this.getBaseUrl();
  },
  watch: {
    i(){
      this.show=true
      this.fileList=[]
      this.$refs.upload.clearFiles()
    }
  },
  data () {
    return {
			show:false,
			loading:false,
			baseUrl:'//zyu.t.ziroom.com',
			formatError: false,
			fileList:[],
			token:getToken(),
			showTip:false
    };
  },
  methods: {
    cancel(){
      this.show = false
    },
    handleSuccess(response, file,fileList){
      this.fileList = fileList
      if(response.code===0){
				 this.$Message.success('导入成功')
				 this.$emit('done')
      }else {
        this.$refs.upload.handleRemove(file)
        this.$Message.error('导入失败,'+response.message)
      }
      this.showTip=false
    },
    beforeUpload(file){
      if (this.fileList.length && this.fileList.find( item => {
        return item.name === file.name
      })){
         this.$Message.error('不能上传重复文件');
        return false
      }
    },
    handleFormatError() {
      this.$Message.error('请输入excel文件')
    },
    handleError() {
      console.log('error')
    },
    onProgress( event, file, fileList){
      this.showTip=true
    },
    getBaseUrl(){
      this.baseUrl=getBaseUrl()
    //   switch (location.host) {
    //     case "zyu.d.ziroom.com":
    //         this.baseUrl = "//zyu.d.ziroom.com";
    //         break;
    //     case "zyu.q.ziroom.com":
    //         this.baseUrl = "//zyu.q.ziroom.com";
		// 		break;
		// 		case "zyu.t.ziroom.com":
    //         this.baseUrl = "//zyu.t.ziroom.com";
    //     break;
    //     case "zyu.ziroom.com":
    //         this.baseUrl = "//zyu.ziroom.com";
    //     break;
    //     default:
    //         this.baseUrl = "//zyu.q.ziroom.com";
    //         break;
    // }
    }
 }
}
</script>

<style lang="css" scoped>
  #download  i{
    padding-right: 4px;
  }
  #tip {
    margin-top:2px;
    border-width:0px;
    background: transparent;
    padding: 0
  }

</style>
